export default __webpack_public_path__ + "static/media/video_classification_before.430467a8.mp4";